/**
 * V64 — Armado y descarga de CSV EN EL CLIENTE.
 *
 * POR QUÉ ACÁ Y NO EN EL BACKEND, que es donde vive csvExportService: el reporte de PTO
 * ya está pivoteado en la pantalla (7 meses × 7 métricas, encabezado de dos niveles) a
 * partir de las filas planas que devuelve `GET /api/pto/reporte`. Un export server-side
 * tendría que escribir ESA MISMA transposición por segunda vez, y dos expresiones de la
 * misma regla desalineadas en silencio es el bug que V44/V48/V49 vienen cerrando. Acá el
 * export es literalmente el arreglo que ya se está renderizando.
 *
 * ⚠ NO ES EL CAMINO PARA SAGE. Los exports de Sage siguen en el backend, y con razón:
 * mutan estado (V37.5 marca pagado+exportado), quedan asentados en `sage_exports` y su
 * formato es un contrato con un sistema externo. Esto es un reporte para que un humano
 * lo abra en Excel y lo compare fila contra fila. No muta nada y no se registra.
 *
 * ⚠⚠ EL BOM VA A PROPÓSITO Y DIVERGE DEL PRECEDENTE. csvExportService NO escribe BOM, y
 * para Sage está bien porque lo lee una máquina. Excel en Windows, en cambio, abre un
 * CSV sin BOM con la codificación del sistema y rompe todos los acentos — o sea la mitad
 * de los apellidos de la planilla. El BOM es lo que hace que "Villavicencio" y "Muñoz"
 * lleguen enteros.
 */

/** Una celda: se entrecomilla solo si hace falta, y las comillas internas se duplican. */
function celda(v) {
  const s = v === null || v === undefined ? '' : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** filas: array de arrays. CRLF porque es lo que Excel espera. */
export function armarCSV(filas) {
  return filas.map(f => f.map(celda).join(',')).join('\r\n');
}

/** El BOM va como ESCAPE, no como carácter literal: un carácter invisible en el fuente
 *  lo borra cualquier editor o linter sin que nadie lo note, y los acentos se rompen
 *  seis meses después sin un cambio que lo explique. */
const BOM = String.fromCharCode(0xFEFF);

export function descargarCSV(nombreArchivo, filas) {
  const blob = new Blob([BOM + armarCSV(filas)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombreArchivo;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
